var React = require('react');
var resolveParameter = require('./resolveParameter');

function Mssg(props, context) {

    var {__direct, __className, __tagName, __key, __parameters, ...remainingProps} = props

    // it's upper case and that's important or else it will be interpreted as a html tag :)
    let TagName = __tagName || 'span'

    // formats text with parameter
    let formattedText = resolveParameter( mc_i18n[ __key.replace("nc_casefactory.", "") ], __parameters );
    let returnValue = __direct || formattedText ;

    remainingProps.className = __className || ''
    remainingProps.dangerouslySetInnerHTML = {__html: returnValue}

    return <TagName {...remainingProps}/>
}

Mssg.contextTypes = {
    //app: React.PropTypes.object.isRequired
}

export default Mssg


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/i18n/Mssg.jsx